module.exports = __webpack_public_path__ + "static/Regulamin-konkursu-Lider-Usług-Publicznych-2021-0e24eeb45f543cb15c356025fd45ad82.pdf";